// extracted by mini-css-extract-plugin
export default {"overlay":"GameCompleted_overlay__c72B7","divider":"GameCompleted_divider__q6HM5","button":"GameCompleted_button__bSk7t"};